<script lang="ts">
  import AppleNew from '@/components/icons/apple-new.svelte'
  import GoogleNew from '@/components/icons/google-new.svelte'
  import Spinner from '@/components/icons/spinner.svelte'
  import { isStandalone, platform } from '@/params'
  import { _ } from 'svelte-i18n'

  export let onGoogleClick: () => void
  export let onAppleClick: () => void
  export let onEmailClick: () => void
  export let isSigningInWithGoogle: boolean
  export let isSigningInWithApple: boolean

  const isChinaServer = location.href.includes('upwardsware')
  const showGoogle = !isChinaServer && (platform === 'android' || isStandalone)

  const buttonClass =
    'flex h-12 w-full items-center justify-center gap-[6px] rounded-xl bg-white/30 px-[6px] font-medium text-[#035462] first:bg-[#035462] first:text-white first:disabled:bg-[#43807F]'
</script>

{#if platform === 'cn_android'}
  <button class={buttonClass} on:click={onEmailClick}>
    <span>{$_('login_btn_seekrauth')}</span>
  </button>

  <button
    class={buttonClass}
    on:click={onAppleClick}
    disabled={isSigningInWithApple}
  >
    {#if isSigningInWithApple}
      <Spinner className="size-6" />
    {:else}
      <AppleNew />
      <span>{$_('login_btn_thirdparty_apple')}</span>
    {/if}
  </button>
{:else}
  {#if showGoogle}
    <button
      class={buttonClass}
      on:click={onGoogleClick}
      disabled={isSigningInWithGoogle}
    >
      {#if isSigningInWithGoogle}
        <Spinner className="size-6" />
      {:else}
        <GoogleNew />
        <span>{$_('login_btn_thirdparty_google')}</span>
      {/if}
    </button>
  {/if}

  <button
    class={buttonClass}
    on:click={onAppleClick}
    disabled={isSigningInWithApple}
  >
    {#if isSigningInWithApple}
      <Spinner className="size-6" />
    {:else}
      <AppleNew />
      <span>{$_('login_btn_thirdparty_apple')}</span>
    {/if}
  </button>

  <button class={buttonClass} on:click={onEmailClick}>
    <span>{$_('login_btn_seekrauth')}</span>
  </button>
{/if}
